/*
 * Chart partitions for task visualization
 */ export var TaskChartMetric = /*#__PURE__*/ function(TaskChartMetric) {
    TaskChartMetric["Late"] = "late";
    TaskChartMetric["NotStarted"] = "notStarted";
    TaskChartMetric["InProgress"] = "inProgress";
    TaskChartMetric["Completed"] = "completed";
    TaskChartMetric["Blocked"] = "blocked";
    return TaskChartMetric;
}({});
/**
 * Maximum and minimum number of bars to display per page
 * Used for both buckets and members charts
 */ export const MAX_BARS_PER_PAGE = 16;
export const MIN_BARS_PER_PAGE = 8;
